import { IUnc, IUserProject } from '@root-gipro/store/interfaces'

export interface SortableByCode {
	[key: string]: string
}
export const sortByCode = <T extends SortableByCode>(data: T[], field: keyof T = 'code'): T[] => {
	const parseCode = (code: string): (string | number)[] => {
		const letterMatch = code.match(/^([А-Яа-яA-Za-z]+)/)
		const numberMatches = code.match(/\d+/g)?.map(Number) || []
		const letterPart = letterMatch ? letterMatch[1] : ''
		return [letterPart, ...numberMatches]
	}

	return data.slice().sort((a, b) => {
		const partsA = parseCode(String(a[field]))
		const partsB = parseCode(String(b[field]))

		for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
			const valA = partsA[i]
			const valB = partsB[i]

			if (valA === undefined) return -1
			if (valB === undefined) return 1

			if (typeof valA === 'string' && typeof valB === 'string') {
				const cmp = valA.localeCompare(valB)
				if (cmp !== 0) return cmp
			} else if (typeof valA === 'number' && typeof valB === 'number') {
				if (valA !== valB) return valA - valB
			}
		}

		return 0
	})
}
export const createUncArr = (tableNum: number, uncs: IUnc[]) => {
	let arr: IUnc[] = []
	if (uncs && uncs.length > 0) {
		if (tableNum === 6) {
			arr = uncs
		} else {
			arr = uncs.filter((unc: IUnc) => unc.tableNum === tableNum)
		}
	}

	return arr
}

export function addActiveUnc(activeUncs: IUnc[], unc: IUnc) {
	const index = activeUncs.findIndex(active => active.id === unc.id),
		clone = activeUncs.slice()
	if (index === -1) {
		clone.push(unc)
	} else {
		clone.splice(index, 1)
	}
	return { clone, index }
}

export function getTargetVoltageValues(buffer: any, id: any) {
	const index = buffer.findIndex((item: any) => {
		return item.id == id
	})
	if (index >= 0) {
		return buffer[index]['targetVoltageValues']
	}
}
export const filterWidthWindow = (step: string | undefined) => {
	switch (step) {
		case 'error-list':
			return '768px'
		case 'errors-list':
			return '768px'
		case 'check-list':
			return '240px'
		case 'unNormalizeForm20Instructions':
			return '1232px'
		case 'open-table-form20':
			return '100%'
		default:
			break
	}
}

export const ROSSETI_ID = 10

export const requiredFields: Array<{ field: keyof Omit<IUserProject, 'author'>; message: string }> = [
	{ field: 'code', message: 'поле «Идентификатор»' },
	{ field: 'groupNum', message: 'поле «Номер группы»' },
	{ field: 'name', message: 'поле «Наименование инвестиционного объекта»' },
	{ field: 'regionIds', message: 'поле «Субъект РФ»' },
	// { field: 'years', message: 'Объем финансирования инвестиций по годам (с НДС)' },
	{ field: 'unc_sort', message: 'режим УНЦ' },
]

// Тексты контента
export const form2Text = `
Имя файла должно соответствовать формату: [произвольное название]-F2_20.12.2023.xlsx, где F2 - ключевой признак формы 2, 20.12.2023 - дата публикации на сайте Минэнерго.
Структура *.xIsx файла должна соответствовать шаблону формы с сайта Минэнерго.

Шаблон можно скачать из меню «Шаблоны» GIPRO УНЦ.

Название компании в форме должно совпадать с названием компании в БД. Можно проверить в фильтре.

В формулах не должно быть ссылок на связанные источники данных (другие листы или файлы).

Нужно загружать формы, содержащие только значения.

Если в исходном файле есть формулы, то можно сделать копию файла (учитывать требования к формату имени файла), в каждом листе скопированного файла скопировать все ячейки и вставить их как значения.
`

export const form20Text = `
Имя файла должно соответствовать формату Минэнерго (содержать огрн).

Структура *.xIsx файла должна соответствовать шаблону формы с сайта Минэнерго.

Шаблон можно скачать из меню «Шаблоны» GIPRO УНЦ.

Форма должна содержать корректные наименования и стоимость расценок.
`

export const importNotes = `
Импорт форм можно производить в различных режимах (УНЦ-2019/2024), а также указывать раздел для импорта: 

1. в раздел «ИПР» (доступно только разработчикам и сотрудникам технической поддержки ООО «MЦP»).

2. в раздел «Проекты» с указанной версией ИПР (доступно пользователям конфигураций системы в контуре компании, к которой они относятся).
Необходимо соблюдать последовательность импорта:

1. форма 2

2. форма 20

При импорте формы 20 выполняется проверка формы на наличие технических ошибок. По 
результатам импорта формы на экране отображается отчет об ошибках, который можно скачать во внешний файл. Итоги проверки также записываются в журнал логов, его можно посмотреть вызвав команду слоги» в главном меню раздела «Проекты»`

export const projectPhases = [
	{
		value: 'П',
		title: `«П» – если в соответствии с законодательством о градостроительной деятельности:
требуется получение разрешения на строительство в отношении объекта капитального строительства, строительство (реконструкция) которого предусматривается инвестиционным проектом, и разрешение на строительство в отношении такого объекта капитального строительства не получено;
получение разрешения на строительство не требуется и проектная документация применительно к объекту капитального строительства, строительство (реконструкция) которого предусматривается инвестиционным проектом, в соответствии с законодательством о градостроительной деятельности не утверждена;`,
		fullName: 'П - требуется получение разрешения на строительство или документация не утверждена',
	},
	{
		value: 'С',
		title: `«С» – если в отношении объекта капитального строительства, строительство (реконструкция) которого предусматривается инвестиционным проектом:
в соответствии с законодательством о градостроительной деятельности выдано разрешение на строительство, но соответствующий объект основных средств не принят сетевой организацией к бухгалтерскому учету;
в соответствии с законодательством о градостроительной деятельности получение разрешения на строительство не требуется и утверждена проектная документация применительно к такому объекту капитального строительства, но соответствующий объект основных средств не принят сетевой организацией к бухгалтерскому учету;`,
		fullName: 'С - разрешение на строительство выдано, объект не принят к бухгалтерскому учету',
	},
	{
		value: 'К',
		title: `«К» – если объект капитального строительства, строительство (реконструкция) которого предусмотрено инвестиционным проектом, законсервирован в соответствии с законодательством о градостроительной деятельности;`,
		fullName: 'К - объект законсервирован',
	},
	{
		value: 'И',
		title: `«И» – если инвестиционным проектом не предусматривается в соответствии с законодательством о градостроительной деятельности строительство (реконструкция) объекта капитального строительства и за период до наступления отчетной даты в рамках реализации инвестиционного проекта сетевой организацией осуществлялись инвестиции в объекты основных средств и (или) нематериальных активов, которые по состоянию на отчетную дату не приняты сетевой организацией к бухгалтерскому учету;`,
		fullName: 'И - осуществлены инвестиции, но объект не принят к учету',
	},
	{
		value: 'Н',
		title: `«Н» – если инвестиционным проектом не предусматривается в соответствии с законодательством о градостроительной деятельности строительство (реконструкция) объекта капитального строительства и за период до наступления отчетной даты в рамках реализации инвестиционного проекта сетевой организацией не осуществлялись инвестиции в объекты основных средств и (или) нематериальных активов, которые по состоянию на отчетную дату не приняты сетевой организацией к бухгалтерскому учету;`,
		fullName: 'Н - инвестиции не осуществлялись',
	},
	{
		value: 'З',
		title: `«З» – если объекты основных средств и (или) нематериальных активов, предусмотренные инвестиционным проектом, приняты сетевой организацией к бухгалтерскому учету.
Под отчетной датой в настоящем пункте понимается 1 января года, в котором сетевой организацией раскрывается информация об инвестиционной программе (о проекте инвестиционной программы и (или) проекте изменений, вносимых в инвестиционную программу) и обосновывающих ее материалах (далее – год Х).
Если в рамках реализации инвестиционного проекта предусматривается выполнение несколько этапов строительства, то информация о текущей стадии реализации указывается через запятую в отношении каждого этапа строительства, а номер этапа строительства указывается в виде префикса к указанной информации (то есть 1С, 2П);`,
		fullName: 'З - объекты приняты к бухгалтерскому учету',
	},
]


export const onAccessTokenFetched = (newToken: string) => {	
	localStorage.setItem('access_token', newToken);
};